import { ComponentProps, useState } from 'react';
import { TaskIdV2, UserId } from 'api/models';
import { Maybe, Nothing } from 'core/maybe';
import { useUser } from 'hooks/use-user';
import { AddTimeEntryDrawerControlled } from './add-time-entry-drawer-controlled';
import { useSaveCancel } from './use-save-cancel';
import { useTimeSpent } from './use-time-spent';

interface Props {
  taskId: TaskIdV2;
  onClose: () => void;
  defaultBillable?: boolean;
  defaultCategory?: Maybe<number>;
}

export const useTimeEntryDrawerProps = ({
  taskId,
  onClose,
  defaultBillable = true,
  defaultCategory = Nothing(),
}: Props): ComponentProps<typeof AddTimeEntryDrawerControlled> => {
  const [minutes, onMinutesChange] = useState<Maybe<number>>(Nothing());
  const [category, onCategoryChange] = useState<Maybe<number>>(defaultCategory);
  const [billable, onBillableChange] = useState(defaultBillable);
  const [notes, onNotesChange] = useState<Maybe<string>>(Nothing());
  const {
    user: { userId },
  } = useUser();
  const { onSave, onCancel } = useSaveCancel({
    taskId,
    onClose,
    minutes,
    category,
    billable,
    notes,
    userId: UserId(userId),
  });
  const { timeSpent } = useTimeSpent(taskId);

  return {
    minutes,
    onMinutesChange,
    billable,
    onBillableChange,
    category,
    onCategoryChange,
    notes,
    onNotesChange,
    timeSpent,
    onSave,
    onCancel,
  };
};
